import { ConsumerLoginStore } from './modules/homepage/login.store';
import { GlobalPopoutStore } from './modules/homepage/popout.store';

export class HomePageRootStore {
    public popoutStore: GlobalPopoutStore;

    public loginStore: ConsumerLoginStore;

    constructor() {
        this.popoutStore = new GlobalPopoutStore(this);
        this.loginStore = new ConsumerLoginStore(this);
    }
}
